export default {
  peopleLabelColor: Styles.color.grey.one,
  cartPreviewItemPColor: Styles.color.grey.one,
};
